/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/24/20
 *
 */

import {Type} from "class-transformer";
import DbBaseObject from '@shared/DbBaseObject.js';
import PaymentIntegrationType from "@shared/Billing/PaymentIntegrationType";
import Token from "@shared/integrations/OAuthToken";
import IntegrationStatus from "@shared/Billing/IntegrationStatus";



export default class PaymentIntegrationItem extends DbBaseObject{


	userId: string = ""
	title: string = ""
	description: string = ""
	type: PaymentIntegrationType = ""

	isIntegrated: boolean = false
	integrationStatus: IntegrationStatus = null

	@Type(() => Token)
	token: Token = null

	constructor() {
		super();
	}

	integrated(){
		return this.integrationStatus === IntegrationStatus.INTEGRATED || (this.isIntegrated && this.integrationStatus == null)
	}
	isDetached(){
		return this.integrationStatus === IntegrationStatus.DETACHED
	}

	setIntegrated(){
		this.integrationStatus = IntegrationStatus.INTEGRATED
	}
	setDetached(){
		this.integrationStatus = IntegrationStatus.DETACHED
	}

	paymentMethodFormatted(){
		return this.title
	}



}



